let arr=[
    {name:'初级职称',value:'初级职称'},
    {name:'中级职称',value:'中级职称'},
    {name:'副高级职称',value:'副高级职称'},
    {name:'高级职称',value:'高级职称'}
]
export default arr